import { apiClient } from './client';

export async function listCustomerPriceAgreements(customerId) {
  const { data } = await apiClient.get(`/api/system/customers/${customerId}/price-agreements`);
  return data.data ?? data;
}

export async function createCustomerPriceAgreement(customerId, payload) {
  const { data } = await apiClient.post(`/api/system/customers/${customerId}/price-agreements`, payload);
  return data.data ?? data;
}

export async function updateCustomerPriceAgreement(customerId, agreementId, payload) {
  const { data } = await apiClient.put(
    `/api/system/customers/${customerId}/price-agreements/${agreementId}`,
    payload,
  );
  return data.data ?? data;
}

export async function activateCustomerPriceAgreement(customerId, agreementId) {
  const { data } = await apiClient.patch(
    `/api/system/customers/${customerId}/price-agreements/${agreementId}/activate`,
  );
  return data.data ?? data;
}

export async function deactivateCustomerPriceAgreement(customerId, agreementId, note) {
  const { data } = await apiClient.patch(
    `/api/system/customers/${customerId}/price-agreements/${agreementId}/deactivate`,
    { note },
  );
  return data.data ?? data;
}

export async function quoteCustomerPriceAgreement(customerId, payload) {
  const { data } = await apiClient.post(
    `/api/system/customers/${customerId}/price-agreements/quote`,
    payload,
  );
  return data.data ?? data;
}
